import { HugeiconsProps } from '@hugeicons/react-native';
import { View } from 'react-native';
import React from 'react';
import { HugeIconsWrapper } from './HugeIconsWrapper';

interface IMenuItemIconProps extends HugeiconsProps {
  className?: string;
}

export function MenuItemIcon({ className = "color-primary-500", ...props }: IMenuItemIconProps) {
  return (
    <View className="mr-3">
      <HugeIconsWrapper className={className} {...props} />
    </View>
  );
}
